let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = Promise.all([load("hPzOn"), load("fzehJ")]).then(() => parcelRequire('j5yhG'));